export const THAP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT as 'development' | 'demo' | 'production'

export const TECH_ASSESSMENT_SHOT = process.env.REACT_APP_TECH_ASSESSMENT_SHOT
export const MAIN_LOGO = process.env.REACT_APP_MAIN_LOGO
export const HEADER_LOGO = process.env.REACT_APP_HEADER_LOGO 
export const FOOTER_LOGO = process.env.REACT_APP_FOOTER_LOGO
export const FOOTER_URL = process.env.REACT_APP_LANDING_PAGE_FOOTER_URL
